import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const AppPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50:  '#f3fcf9',
            100: '#c6eee1',
            200: '#98e1c9',
            300: '#6bd4b1;',
            400: '#3dc699',
            500: '#10b981;',
            600: '#0e9d6e',
            700: '#0b825a',
            800: '#096647',
            900: '#064a34',
            950: '#064a34'
        },
    },
    components: {
        menubar:{
            colorScheme: {                
                light: {
                    root: {
                    },                 
                    item:{
                        activeBackground:'{red.700}',//No funciona
                        activeColor: '{red.700}',//No funciona
                    },

                }
            }
        },
        datatable:{
            colorScheme:{
                light:{
                    header:{
                        background:'{surface.50}',
                        borderWidth:'1px 0',
                        borderColor:'{surface.200}'
                    },
                    headerCell:{
                        background:'{surface.50}'
                    },
                    columnTitle:{
                        

                    }
                    
                }
            }
        },
        accordion:{
            panel:{
                borderWidth:'0',
            },
            header:{
                background: '{surface.50}',
                hoverBackground:'{surface.200}',
                activeBackground:'{surface.50}',
                activeHoverBackground:'{surface.200}',
                borderRadius: '1px 1px 0 0 ',
                borderColor: '{surface.200}'
            },
            content:{
                borderWidth:'0 1px 1px 1px',
                borderColor: '{surface.200}',
            },            

        }
    }
});


